export default __webpack_public_path__ + "static/media/od-logo.96acad38.png";